import instance from "../axios";
import TokenManager from "./TokenManager";

export const getNewToken = () => {
    return instance.get('token');
}